import React, {Component} from 'react';
import {connect} from 'react-redux';
import Loader from "../../../../../../../../components/sprite/components/loader";
import Avatar from "../../../../../../../../components/avatar";
import './index.css';
import {permissionCleaner, APP_URL} from "../../../../../../../../utils";

class ViewCollaboratorsList extends Component {
    render() {
        if(this.props.findCollaborators !== null){
            return (
                <div className="view-collaborators-list border-bottom">
                    {
                        this.props.findCollaborators.collaborators.map(collaborator => (
                            <div key={collaborator.id}>
                                <div className="d-flex align-items-center">
                                    {
                                        collaborator.type === 'user'
                                        ?
                                            <Avatar size={36} className="mr-3 border-0" src={`${APP_URL}/account/avatar/${collaborator.id}`} />
                                        :
                                            <Avatar size={36} className="mr-3 border-0" src={'/img/collaborators-group.svg'} />
                                    }
                                    <div className="text-truncate">
                                        {
                                            collaborator.name
                                            ?
                                                <div className="text-nowrap">
                                                    <strong>{collaborator.name}</strong> - {collaborator.email} - <em>({permissionCleaner(collaborator.permission)})</em>
                                                </div>
                                            :
                                                <div className="text-nowrap">{collaborator.email} - <em>({permissionCleaner(collaborator.permission)})</em></div>
                                        }
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            );
        } else {
            return (
                <div>
                    <Loader/>
                </div>
            )
        }
    }
}

const mapStateToProps = (state) => {
    return {
        findCollaborators : state.sharingDetailsReducer.findCollaborators,
    };
};

export default connect(mapStateToProps)(ViewCollaboratorsList);
